import React from 'react'
import { connect } from 'react-redux'
import { Location } from 'history'
import HeadData from 'components/Common/HeadData'
import Spacing from 'components/Common/Spacing'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import ContactUsForm from './ContactUsForm'
import LegalPages from 'components/Pages/LegalPages'
import config from 'constants/config'
import BodyText from 'components/Luxkit/Typography/BodyText'

interface Props {
  phone: App.GeoContacts;
  location: Location<any>;
  slug: string;
}

function NewsPage(props: Props) {
  const { phone, location, slug } = props
  const contactPhone = phone[phone.default].humanReadable || '+61 2 8320 6845'
  const callUs = `You can call our friendly customer support team on ${contactPhone}`

  // There are inconsistencies in Contentful slug-naming schemes
  // ...so that this one luxuryescapes item needs "luxuryescapes-" prefix in the slug
  // Other brands slug-name brand prefixes are handled in the LegalPages component
  const brandedSlug = config.BRAND === 'luxuryescapes' ?
    `${config.BRAND}-${slug}-content-page` :
    `${slug}-content-page`

  return <>
    <HeadData
      title="Latest News"
      description={`Latest News about ${config.title}`}
    />
    <Pane type="clear">
      <PaneBody size="lg">
        <LayoutContainer>
          <LegalPages slug={brandedSlug} location={location} />
          {config.contactForm && <ContactUsForm />}
          <Spacing mt={50}>
            <BodyText variant="large" weight="bold" as="h3">{callUs}</BodyText>
          </Spacing>
        </LayoutContainer>
      </PaneBody>
    </Pane>
  </>
}

const mapStateToProps = (state: App.State) => ({
  phone: state.geo.currentContact,
})

export default connect(mapStateToProps)(NewsPage)
